(() => {
  if (window.OutlumiScrollCarousel) return;
  window.OutlumiScrollCarousel = class {
    constructor(root, viewport, items, changed) {
      Object.assign(this, {root, viewport, items, changed, index: 0});
      this.abort = new AbortController();
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      const options = {signal: this.abort.signal};
      viewport.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }, {...options, passive: true});
      viewport.addEventListener('dragstart', event => event.preventDefault(), options);
      viewport.addEventListener('pointerdown', event => {
        this.ignoreClick = false;
        if (event.pointerType === 'touch' || event.button !== 0) return;
        const left = viewport.scrollLeft;
        viewport.style.scrollSnapType = 'none';
        viewport.scrollTo({left, behavior: 'instant'});
        this.pointer = {id: event.pointerId, x: event.clientX, y: event.clientY, left, lastX: event.clientX, time: performance.now(), velocity: 0, dragging: false};
        const pointer = this.pointer;
        cancelAnimationFrame(this.cancelScrollFrame);
        this.cancelScrollFrame = requestAnimationFrame(() => {
          if (this.pointer === pointer) viewport.scrollTo({left: pointer.left - (pointer.lastX - pointer.x), behavior: 'instant'});
        });
      }, options);
      viewport.addEventListener('pointermove', event => {
        const pointer = this.pointer;
        if (!pointer || pointer.id !== event.pointerId) return;
        const dx = event.clientX - pointer.x, dy = event.clientY - pointer.y;
        if (!pointer.dragging) {
          if (Math.abs(dy) > 8 && Math.abs(dy) > Math.abs(dx)) { this.pointer = null; viewport.style.scrollSnapType = ''; return; }
          if (Math.abs(dx) < 6 || Math.abs(dx) <= Math.abs(dy)) return;
          pointer.dragging = true;
          viewport.setPointerCapture(event.pointerId);
          root.classList.add('is-dragging');
        }
        event.preventDefault();
        const now = performance.now();
        pointer.velocity = (event.clientX - pointer.lastX) / Math.max(1, now - pointer.time);
        pointer.time = now; pointer.lastX = event.clientX;
        viewport.scrollLeft = pointer.left - dx;
      }, options);
      const finish = event => {
        const pointer = this.pointer;
        if (!pointer || pointer.id !== event.pointerId) return;
        this.pointer = null;
        viewport.style.scrollSnapType = '';
        if (!pointer.dragging) return;
        this.ignoreClick = true;
        root.classList.remove('is-dragging');
        const velocity = performance.now() - pointer.time < 100 ? pointer.velocity : 0;
        const projected = viewport.scrollLeft - velocity * 160;
        const next = event.type === 'pointercancel' ? this.index : Math.max(0, Math.min(items.length - 1, Math.round(projected / viewport.clientWidth)));
        this.show(next);
      };
      window.addEventListener('pointerup', finish, options);
      window.addEventListener('pointercancel', finish, options);
      viewport.addEventListener('click', event => {
        if (this.ignoreClick && event.detail) { event.preventDefault(); event.stopPropagation(); this.ignoreClick = false; }
      }, {...options, capture: true});
      this.resize = new ResizeObserver(() => viewport.scrollTo({left: this.index * viewport.clientWidth, behavior: 'instant'}));
      this.resize.observe(viewport);
      this.update();
    }
    update() {
      if (!this.viewport.clientWidth) return;
      this.index = Math.max(0, Math.min(this.items.length - 1, Math.round(this.viewport.scrollLeft / this.viewport.clientWidth)));
      this.items.forEach((item, i) => { item.inert = i !== this.index; item.setAttribute('aria-hidden', String(i !== this.index)); });
      this.changed?.(this.index);
    }
    show(next) {
      if (!this.items.length) return;
      const index = (next % this.items.length + this.items.length) % this.items.length;
      this.viewport.scrollTo({left: index * this.viewport.clientWidth, behavior: this.motion.matches ? 'instant' : 'smooth'});
      if (this.motion.matches) this.update();
    }
    destroy() {
      this.abort.abort(); this.resize.disconnect(); cancelAnimationFrame(this.frame); cancelAnimationFrame(this.cancelScrollFrame);
      this.root.classList.remove('is-dragging'); this.viewport.style.scrollSnapType = '';
      this.items.forEach(item => { item.inert = false; item.removeAttribute('aria-hidden'); });
    }
  };
})();
